module.exports = __webpack_public_path__ + "static/media/avadhoot_ghewade.c8f2330d.png";